import { SeverityLevel } from "@microsoft/applicationinsights-common";
import { getAppInsights } from "./appInsightsService";

export const removeFields = card => {
    const cloned = { ...card };
    
    delete cloned.cardRender;
    delete cloned.photo;

    return cloned;
};

const trackTrace = (trace) => {
    try {
        let insights = getAppInsights();
        if (insights) {
            insights.trackTrace(trace);
        } else {
            console.error('app insights failed');
        }
    } catch (e) {
        console.error('app insights failed', e);
    }
};

const info = (message, data) => {
    console.log(`[INFO] ${message}`, data);
    trackTrace({
        message: message,
        properties: data,
        severityLevel: SeverityLevel.Information
    });
};

const warning = (message, data) => {
    console.log(`[WARN] ${message}`, data);
    trackTrace({
        message: message,
        properties: data,
        severityLevel: SeverityLevel.Warning
    });
};

const error = (error) => {
    console.log(`[ERR] ${error}`);
    trackTrace({ exception: error });
};

const event = (name, properties) => {
    trackTrace({
        name,
        properties
    });
};

const logService = { info, warning, error, event };

export default logService;